import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  PurchaseDetail,
  type PurchaseDetailProps,
} from "@/features/staff/purchasing/purchase-detail"

export default function StaffLocationManagePurchasesShow(props: PurchaseDetailProps) {
  return (
    <StaffLayout>
      <PurchaseDetail {...props} />
    </StaffLayout>
  )
}
